import { Language } from '@coolblue-development/constants';
import { Value } from '@features/product/components/Collection/Collection.types';

export const getPercentageDiscount = (value: Value) => {
  const { product } = value;

  if (!product || !product?.subProducts?.length) {
    return null;
  }

  const salesPrice = product.nullableSalesPrice?.includingVat;
  const listPrice = product.listPrice?.includingVat;

  if (!listPrice || listPrice === 0 || !salesPrice) {
    return null;
  }

  const percentage = Math.round(((listPrice - salesPrice) / listPrice) * 100);

  return percentage > 0 ? percentage : null;
};

export const getFlatDiscount = (value: Value) => {
  const { product } = value;

  if (!product) {
    return null;
  }

  const salesPrice = product.nullableSalesPrice?.includingVat;
  const listPrice = product.listPrice?.includingVat;

  if (!listPrice || !salesPrice) {
    return null;
  }

  return Math.round(listPrice - salesPrice);
};

export const getPriceDifference = (currentValue?: Value, value?: Value) => {
  const currentProductPrice =
    currentValue?.product?.personalPrice?.price.includingVat ??
    currentValue?.product?.nullableSalesPrice?.includingVat;
  const valuePrice =
    value?.product?.personalPrice?.price.includingVat ??
    value?.product?.nullableSalesPrice?.includingVat;

  if (!currentProductPrice || !valuePrice) {
    return 0;
  }

  return Math.round(valuePrice - currentProductPrice);
};

export const getLanguageSpecificPrice = (
  price: number,
  language: Language,
  isPercentage?: boolean
) => {
  if (isPercentage) {
    return `${price}%`;
  }

  return language === Language.GERMAN || language === Language.FRENCH ? `€ ${price}` : `${price},-`;
};
